module.exports = __webpack_public_path__ + "media/fan.16dc7021.mp3";